import { Component, OnDestroy, OnInit } from '@angular/core';
import { Sensor, excludedSensorTypes, IValue, ApplianceTypes } from 'src/app/models/sensor';
import { Router, ActivatedRoute } from '@angular/router';
import { Zone } from 'src/app/models/zone';
import { Appliance } from 'src/app/models/appliance';
import { DataService } from 'src/app/services/data.service';
import { SocketIoService } from 'src/app/services/socket-io.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ZoneService } from '../../../services/zone.service';


export interface Category {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.less']
})
export class OverviewComponent implements OnInit, OnDestroy {
  zones: any | null = null;
  currentCompany: any = null
  currentCompanyId: string | null = null
  
  subscription: Subscription;
  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private socketService: SocketIoService,
    private zoneService: ZoneService,) {

      this.dataService.sharedCompany$.subscribe(company => {
        this.currentCompany = company;
      })

      this.dataService.sharedCompanyId$.subscribe(companyId => {
        this.currentCompanyId = companyId;
        if (!companyId && localStorage.getItem('currentCompany')) {
          let company = JSON.parse(localStorage.getItem('currentCompany'));

          this.currentCompany = company ? company.name : null
          this.currentCompanyId = company ? company._id : null
        }
      })

      this.subscription = this.dataService.sharedZones$.subscribe(zones=> {
        this.zones = zones;
      })
  }

  ngOnInit(): void {
    // this.getZones();
  }

  getZones(): void {
    // let companyId = this.currentCompany ? this.currentCompany._id : this.currentCompanyId
    this.zoneService.companyZones(this.currentCompanyId).subscribe((response: Zone[]) => {

        this.zones = response;
        if(this.zones.length === 0){
          let company = {_id: this.currentCompanyId, name: this.currentCompany}
          localStorage.setItem('currentCompany', JSON.stringify(company));
        }
        let listOfZones = this.zones.map(x => {
            return { _id: x._id, name: x.name }
        })

        localStorage.setItem('zoneList', JSON.stringify(listOfZones));

        if(this.zones.length){
          this.currentCompany = this.zones[0]['company']
          let company = {_id: this.zones[0]['company']._id, name: this.zones[0]['company'].name}
          localStorage.setItem('currentCompany', JSON.stringify(company));
          this.dataService.updateCompany(this.zones[0]['company'].name)
          this.dataService.updateCompanyId(this.zones[0]['company']._id)
      }

      let sensors: any  = []
        this.zones.forEach(zone => {
            zone.reducedSensors = Sensor.breakdownSensors(zone.sensors, zone.alerts);
            zone.alertSensors = Sensor.reduceSensorAlerts(zone.sensors, zone.alerts);
            zone.alertAppliances = Sensor.reduceApplianceAlerts(zone.sensors, zone.alerts, ['status']);

            zone.sensors.forEach(sensor => {
              sensor.zone = zone._id
              sensors.push(sensor)
            });
           
        })

      this.dataService.updateSensors(sensors)
      this.dataService.updateZones(this.zones);

        this.dataService.zones = this.zones;
    }, (err) => {
        switch (err.status) {
            case 401:
                //   this._logger.info('Incorrect');
                break;
        }
    }, () => {
        //   this._logger.info('Completed')
    });
}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  updateCurrentZone(zone: Zone) {
    this.dataService.updateZone(zone);
  }

  updateZones(){
    this.getZones();
  }

}
